import { IDefineCommand, ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ScheduledSectionStatus } from '../../views/course_scheduler/types/scheduled_section_status_enum';
import { ISectionSwapToFrom } from '../models/course_section_swap_model';
import { ISection } from '../../interfaces/scheduler_interfaces';

angular
  .module('capability-ng-scheduler')
  .service(
    'saveSwapToSectionCommand',
    function saveSwapToSectionCommandDefinition(
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      ngCourseSectionSwapModel: any,
      log: any,
      updateSwapSectionStatusCommand: ICommand
    ) {
      'use strict';

      return defineCommandORM(
        'saveSwapToSectionCommand',
        function saveSwapToSectionCommand(deferred, toSection: ISection) {
          const prevToSections = ngCourseSectionSwapModel.read().swap_to_section_ids;
          const fromSections = ngCourseSectionSwapModel.read().swap_from_section_ids;
          const isMultiSection = _4.get(toSection, '_course._has_multi_section_types', false);

          const selectedSection: ISectionSwapToFrom = {
            id: toSection.id,
            course: toSection.course,
            session: _4.get(toSection, '_section_type.session', -1),
            section_type: toSection.section_type
          };

          let to_sections: ISectionSwapToFrom[] = [];
          let sectionsToClear: ISectionSwapToFrom[];

          const hasPreviousSection = !_4.isEmpty(prevToSections);
          const isCourseSame = !_4.isEmpty(_4.find(prevToSections, { course: toSection.course }));
          const swapingSameSection = _4.find(fromSections, { id: toSection.id });

          // Prevent same section swap
          if (swapingSameSection && !isMultiSection) {
            deferred.reject({ error: 'same_section' });
            return;
          }

          if (isMultiSection && isCourseSame && hasPreviousSection) {
            // Clear same section type in same session
            sectionsToClear = _4.filter(prevToSections, {
              section_type: selectedSection.section_type,
              session: selectedSection.session
            });

            to_sections = _4.filter(
              prevToSections,
              (item: ISectionSwapToFrom) => item.section_type !== selectedSection.section_type
            );
            to_sections.push(selectedSection);
          } else {
            to_sections = [selectedSection];
            sectionsToClear = prevToSections;
          }

          updateSwapSectionStatusCommand(_4.compact(_4.map(sectionsToClear, 'id')), '');
          updateSwapSectionStatusCommand(_4.compact(_4.map(to_sections, 'id')), ScheduledSectionStatus.PENDING);

          // Reset to sections, because write will only merge
          ngCourseSectionSwapModel.read().swap_to_section_ids = [];

          ngCourseSectionSwapModel.write({
            swap_to_section_ids: to_sections,
            isMultiSection
          });

          deferred.resolve();
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/swap/commands/save_swap_to_section_command.ts